export const getCsrfToken = () => {
  const cookies = document.cookie.split('; ');
  for (const c of cookies) {
    const [key, ...val] = c.split('=');
    if (key === 'csrf_access_token') {
      return val.join('=');
    }
  }
  return '';
};

// Get refresh token
export const getRefreshToken = () => {
  const cookies = document.cookie.split('; ');
  for (const c of cookies) {
    const [key, ...val] = c.split('=');
    if (key === 'csrf_refresh_token') {
      return val.join('=');
    }
  }
  return '';
};